<ng-template #ngContent>
  <ng-content></ng-content>
</ng-template>

<ng-template #deleteTpl let-modal>
  <ng-container *ngTemplateOutlet="modalHeader; context{modal:modal}"/>
  <ng-container *ngTemplateOutlet="modalBody"/>
  <!-- Action: wait - show spinner - no action allowed -->
  <ng-container *ngTemplateOutlet="actionWait"/>
  <!-- Action: process - allow cancel and confirm -->
  @if (action === 'process' && footer === 'delete') {
    <div class="modal-footer">
      <acc-button status="danger" (accClick)="onConfirm($event)">
        {{ config.deleteConfirmMsgCode|translate }}
      </acc-button>
      <acc-button class="ms-auto" status="outline-gray" (accClick)="onCancel($event)">
        {{ config.deleteCancelMsgCode|translate }}
      </acc-button>
    </div>
  }
  <!-- Action: cancel - allow only cancel -->
  @if (action === 'cancel' && footer === 'delete') {
    <div class="modal-footer">
      <acc-button class="ms-auto" status="outline-gray" (accClick)="onCancel($event)">
        {{ config.deleteCancelMsgCode|translate }}
      </acc-button>
    </div>
  }
</ng-template>

<ng-template #inputTpl let-modal>
  <ng-container *ngTemplateOutlet="modalHeader; context{modal:modal}"/>
  <ng-container *ngTemplateOutlet="modalBody"/>
  <!-- Action: wait - show spinner - no action allowed -->
  <ng-container *ngTemplateOutlet="actionWait"/>
  <!-- Action: process - allow cancel and confirm / + cancel -->
  <div class="modal-footer">
    @if (action === 'process') {
      <acc-button #inputConfirmButton
                  (accClick)="onConfirm($event)"
                  [loadingTimeout]="config.inputConfirmLoadingTimeout">
        {{ config.inputConfirmMsgCode|translate:config.inputConfirmMsgParams }}
      </acc-button>
    }
    <!-- Action: process / + cancel - allow only cancel -->
    @if (action === 'process' || action === 'cancel') {
      <acc-button #inputCancelButton class="ms-auto" status="outline-gray" (accClick)="onCancel($event)">
        {{ config.inputCancelMsgCode|translate }}
      </acc-button>
    }
  </div>
</ng-template>

<ng-template #showTpl let-modal>
  <ng-container *ngTemplateOutlet="modalHeader; context{modal:modal}"/>
  <ng-container *ngTemplateOutlet="modalBody"/>
  <!-- Action: wait - show spinner - no action allowed -->
  <ng-container *ngTemplateOutlet="actionWait"/>
  <!-- Action:  allow only cancel -->
  @if (footer !== 'none') {
    <div class="modal-footer">
      <acc-button class="ms-auto" status="outline-gray" (accClick)="onCancel($event)">
        {{ config.inputCancelMsgCode|translate }}
      </acc-button>
    </div>
  }
</ng-template>

<ng-template #modalHeader let-modal="modal">
  @if (title) {
    <div class="modal-header">
      <div class="d-flex gap-2">
        @if (titleIconName) {
          <acc-icon [name]="titleIconName" size="xl"/>
        }
        <h5 class="modal-title">{{ title }}</h5>
      </div>
      <button type="button" class="btn-close"
              [attr.aria-label]="config.closeMsgCode|translate"
              (click)="modal.dismiss()"></button>
    </div>
  }
</ng-template>

<ng-template #modalBody>
  @if (action === 'process' || action === 'cancel') {
    <div class="panel-content modal-body">
      @if (body) {
        <p>{{ body }}</p>
      }
      <ng-container *ngTemplateOutlet="ngContent"/>
    </div>
  }
</ng-template>

<ng-template #actionWait>
  @if (action === 'wait') {
    <acc-spinner/>
    <div class="modal-footer mt-4"></div>
  }
</ng-template>
